export default [
  'aan',
  'achte',
  'achter',
  'af',
  'al',
  'alle',
  'alleen',
  'alles',
  'als',
  'ander',
  'anders',
  'beetje',
  'behalve',
  'beide',
  'beiden',
  'ben',
  'beneden',
  'bent',
  'bij',
  'bijna',
  'bijv',
  'blijkbaar',
  'blijken',
  'boven',
  'bv',
  'daar',
  'daardoor',
  'daarin',
  'daarna',
  'daarom',
  'daaruit',
  'dan',
  'dat',
  'de',
  'deden',
  'deed',
  'derde',
  'derhalve',
  'dertig',
  'deze',
  'dhr',
  'die',
  'dit',
  'doe',
  'doen',
  'doet',
  'door',
  'drie',
  'duizend',
  'echter',
  'een',
  'eens',
  'eerst',
  'eerste',
  'eigen',
  'eigenlijk',
  'elk',
  'elke',
  'en',
  'enige',
  'er',
  'erg',
  'ergens',
  'etc',
  'etcetera',
  'even',
  'geen',
  'genoeg',
  'geweest',
  'haar',
  'haarzelf',
  'had',
  'hadden',
  'heb',
  'hebben',
  'hebt',
  'hedden',
  'heeft',
  'heel',
  'hem',
  'hemzelf',
  'hen',
  'het',
  'hetzelfde',
  'hier',
  'hierin',
  'hierna',
  'hierom',
  'hij',
  'hijzelf',
  'hoe',
  'honderd',
  'hun',
  'ieder',
  'iedere',
  'iedereen',
  'iemand',
  'iets',
  'ik',
  'in',
  'inderdaad',
  'intussen',
  'is',
  'ja',
  'je',
  'jij',
  'jijzelf',
  'jou',
  'jouw',
  'jullie',
  'kan',
  'kon',
  'konden',
  'kun',
  'kunnen',
  'kunt',
  'laatst',
  'later',
  'lijken',
  'lijkt',
  'maak',
  'maakt',
  'maakte',
  'maakten',
  'maar',
  'mag',
  'maken',
  'me',
  'meer',
  'meest',
  'meestal',
  'men',
  'met',
  'mevr',
  'mij',
  'mijn',
  'minder',
  'miss',
  'misschien',
  'missen',
  'mits',
  'mocht',
  'mochten',
  'moest',
  'moesten',
  'moet',
  'moeten',
  'mogen',
  'mr',
  'mrs',
  'mw',
  'na',
  'naar',
  'nam',
  'namelijk',
  'nee',
  'neem',
  'negen',
  'nemen',
  'nergens',
  'niemand',
  'niet',
  'niets',
  'niks',
  'noch',
  'nochtans',
  'nog',
  'nooit',
  'nu',
  'nv',
  'of',
  'om',
  'omdat',
  'ondanks',
  'onder',
  'ondertussen',
  'ons',
  'onze',
  'onzeker',
  'ooit',
  'ook',
  'op',
  'over',
  'overal',
  'overige',
  'paar',
  'per',
  'recent',
  'redelijk',
  'samen',
  'sinds',
  'steeds',
  'te',
  'tegen',
  'tegenover',
  'thans',
  'tien',
  'tiende',
  'tijdens',
  'tja',
  'toch',
  'toe',
  'tot',
  'totdat',
  'tussen',
  'twee',
  'tweede',
  'u',
  'uit',
  'uw',
  'vaak',
  'van',
  'vanaf',
  'veel',
  'veertig',
  'verder',
  'verscheidene',
  'verschillende',
  'via',
  'vier',
  'vierde',
  'vijf',
  'vijfde',
  'vijftig',
  'volgend',
  'volgens',
  'voor',
  'voordat',
  'voorts',
  'waar',
  'waarom',
  'waarschijnlijk',
  'wanneer',
  'waren',
  'was',
  'wat',
  'we',
  'wederom',
  'weer',
  'weinig',
  'wel',
  'welk',
  'welke',
  'werd',
  'werden',
  'werder',
  'whatever',
  'wie',
  'wij',
  'wijzelf',
  'wil',
  'wilden',
  'willen',
  'word',
  'worden',
  'wordt',
  'zal',
  'ze',
  'zei',
  'zeker',
  'zelf',
  'zelfde',
  'zes',
  'zeven',
  'zich',
  'zij',
  'zijn',
  'zijzelf',
  'zo',
  'zoals',
  'zodat',
  'zou',
  'zouden',
  'zulk',
  'zullen',
]
